/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* LAZÚ — Abrir primeiro accordion da PDP Premium */

(function () {
  function abrirPrimeiroAccordion() {
    if (!document.body.querySelector(".lazu-premium-shipping")) return;

    const primeiro = document.querySelector(
      ".product__block.product__accordions " +
      ".product__accordion__title[data-collapsible-trigger]"
    );

    if (!primeiro || primeiro.classList.contains("is-expanded")) return;

    primeiro.click();
  }

  document.addEventListener("DOMContentLoaded", function () {
    requestAnimationFrame(abrirPrimeiroAccordion);
  });

  document.addEventListener("shopify:section:load", function () {
    requestAnimationFrame(abrirPrimeiroAccordion);
  });
})();